import { createSelector } from 'reselect';
import ComplianceResconConsignmentIdNotInPreconDetailsColumns
  from '../../containers/ComplianceResconConsignmentIdNotInPreconDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.RESCON_CONSIGNMENT_ID_NOT_IN_PRECON_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.RESCON_CONSIGNMENT_ID_NOT_IN_PRECON_DETAILS.isLoading;

export const getData =
  ReportDefinitions.RESCON_CONSIGNMENT_ID_NOT_IN_PRECON_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, ComplianceResconConsignmentIdNotInPreconDetailsColumns);
